import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import Autocomplete from "react-autocomplete";
//mport PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $, { data } from "jquery";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import axios from "axios";
import moment from "moment";
import deactive from '../../../../assets/img/svg/deactive.svg';
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import { filedeleteiados, cfiledeleteiados } from "../../../../actions/IADOSAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import API from "../../../../_helpers/endpointService";
import { getIADOS_ListView, deleteIADOS } from "../../../../actions/IADOSAction";
import { TextField, InputBase, Radio, RadioGroup, InputAdornment, IconButton, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import InnerImageZoom from "react-inner-image-zoom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));


class EditIADOS extends Component {
    constructor(props) {
        super(props)
        this.inputCPhoto = React.createRef();
        this.inputPhoto = React.createRef();
        this.state = {
            isMobile: false,
            cancel: false,
            Photos: {},
            linkValue: 0,
            CPhotos: [],
            ProjectId: 0,
            ViewDate: "",
            ViewData: [],
            DelIndex: 0,
            index: 0,
            filename: "",
            awsname: "",
            value: 0,
            value1: 0,
            isView: false,
            DeleteData: [],
            DelIndex: 0,
            Error: {
                DateError: false,
                LocationError: false,
                CategoryError: false,
                StatusError: false,
                ObservationError: false,
                CorrectiveActionError: false,
                ResponsibleDepartmentError: false,
                PhotoError: false,
                TargetDateError: false,
                TotalFindingsError: false,
                MajorCloseError: false,
                MinorCloseError: false,
                TotalMajorError: false,
                TotalMinorError: false,
            },
            Initial: {
                "Id": 0,
                "ProjectId": 0,
                "TotalFindings": '',
                "TotalMajor": '',
                "TotalMinor": '',
                "NoofFindingsClose": '',
                "NoofFindingsOpen": '',
                "MajorClose": '',
                "MinorClose": '',
                "MinorOpen": '',
                "MajorOpen": '',
                "Modify": ''
            },
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Location": "",
                "Status": "",
                "Category": "",
                "Observation": "",
                "CorrectiveAction": "",
                "ResponsibleDepartment": "",
                "CompletionDate": null,
                "TargetDate": "",
                "Date": "",
                "Comments": "",
                "ModifiedBy": ""
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.Initial.Modify = localStorage.getItem("UserRoles");
        window.location.pathname == '/initialauditdailyobservationstatus/edit' ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("IADOSEditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.Initial.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.value1 = localStorage.getItem("InitialAuditValue")
        this.state.linkValue = parseInt(localStorage.getItem("InitialAuditValue"));
        let tempdata = {
            data: parseInt(localStorage.getItem("IADOSEditId"))
        }

        this.props.dispatch(getlookupdocinfo("DailyObservation"))
        this.state.DeleteData.push(tempdata)
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.Initial.Id = parseInt(localStorage.getItem("AuditEditId"))
        this.setState({})
        this.geteditaudit(this.state.Initial.Id)
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        if (window.location.pathname == "/initialauditdailyobservationstatus/view") {
            this.state.ViewDate = localStorage.getItem("IADOSViewId")
            this.setState({})
            this.ViewPage(this.state.ProjectId, this.state.ViewDate);
        } else {
            this.geteditiadosdocinfo(this.state.addData.Id)
        }
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))

    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Initial1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Initial").addClass("d-none");
        $("#Initial").removeClass("d-block");
        $("#IADOSL").removeClass("active-color");
        $("#IADOST").removeClass("fw-bolder");
    }
    ViewPage = (id, date) => {
        let apiUrl = API.IADOS_LISTVIEW + '/' + date;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.ViewData = response.data;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (this.state.linkValue === 0) {
            this.gethistorylogIADOS(this.state.ProjectId)
        }
        else {
            this.gethistorylogIA(this.state.ProjectId)
        }
        this.setState({})
    };
    gethistorylogIADOS = (id) => {
        let apiUrl = API.HISTORY_LOG + id + '?name=DailyObservation'
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });

    };
    gethistorylogIA = (id) => {
        let apiUrl = API.HISTORY_LOG + id + '?name=InitialAudit'
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });

    };
    geteditaudit = (id) => {
        let apiUrl = API.INITIAL_AUDIT + '/' + id;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.Initial.Id = response.data.Id;
                    this.state.Initial.TotalFindings = response.data?.TotalFindings;
                    this.state.Initial.NoofFindingsClose = response.data?.NoofFindingsClose;
                    this.state.Initial.NoofFindingsOpen = response.data?.NoofFindingsOpen;
                    this.state.Initial.MajorClose = response.data?.MajorClose;
                    this.state.Initial.MinorClose = response.data?.MinorClose;
                    this.state.Initial.MinorOpen = response.data?.MinorOpen;
                    this.state.Initial.MajorOpen = response.data?.MajorOpen;
                    this.state.Initial.TotalMajor = response.data?.TotalMajor;
                    this.state.Initial.TotalMinor = response.data?.TotalMinor;

                    this.setState({})

                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    }
    geteditiadosdocinfo = (id) => {
        let apiUrl = API.IADOS_LISTVIEW + '/' + id;

        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Location = response.data?.Location;
                    this.state.addData.Status = response.data?.Status;
                    this.state.addData.Category = response.data?.Category;
                    this.state.addData.Observation = response.data?.Observation;
                    this.state.addData.CorrectiveAction = response.data?.CorrectiveAction;
                    this.state.addData.ResponsibleDepartment = response.data?.ResponsibleDepartment;
                    this.state.addData.CompletionDate = response.data?.CompletionDate;
                    this.state.addData.TargetDate = response.data?.TargetDate;
                    this.state.addData.Date = response.data?.Date;

                    this.state.addData.Comments = response.data?.Comments;
                    this.state.Photos = {
                        FileName: response.data.Photos.FileName,
                        ObjectKey: response.data.Photos.ObjectKey,
                        AwsFolderName: response.data.Photos.AwsFolderName,
                        AwsUniqueFileName: response.data.Photos.AwsUniqueFileName,
                        FileExtention: response.data.Photos.FileExtention,
                        FileUrl: response.data.Photos.FileUrl,
                        FileSize: response.data.Photos.FileSize,
                    }
                    this.setState({})
                    if (response.data?.CompletionPhotos.length > 0) {
                        response.data?.CompletionPhotos.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.CPhotos = response.data?.CompletionPhotos;
                        this.setState({})
                    }

                    this.setState({})

                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    }
    AttachFiles = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.inputCPhoto.current.click();
    };
    AttachFiles1 = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.inputPhoto.current.click();
    };
    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.setState({});
        if (node === "Observation") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.Observation = e.target.value;
            }
        } else if (node === "CorrectiveAction") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.CorrectiveAction = e.target.value;
            }
        } else if (node === "ResponsibleDepartment") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.ResponsibleDepartment = e.target.value;
            }
        } else if (node === "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.Comments = e.target.value;
            }
        } else {
            this.state.addData[node] = e.target.value;
        }
        this.setState({});
    };
    handleDateChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node === "CompletionDate") {
            if (e.target.value === "") {
                this.state.addData[node] = null
                this.setState({});
            }
            else {
                this.state.addData[node] = e.target.value
                this.setState({});
            }
        }
        else {
            this.state.addData[node] = e.target.value
            this.setState({});
        }
    };
    handleNumberChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.setState({});
        if (e.target.value == '') {
            this.state.Initial[node] = ''
            this.setState({});
        }
        else {
            this.state.Initial[node] = parseInt(e.target.value)
            this.setState({});
        }
        if (this.state.Initial.MajorClose != '' && this.state.Initial.MinorClose != '') {
            this.state.Initial.NoofFindingsClose = this.state.Initial.MajorClose + this.state.Initial.MinorClose
            this.setState({})
        }
        else if (this.state.Initial.MajorClose != '') {
            this.state.Initial.NoofFindingsClose = this.state.Initial.MajorClose
            this.setState({})
        }
        else {
            this.state.Initial.NoofFindingsClose = this.state.Initial.MinorClose
            this.setState({})
        }
        if (this.state.Initial.TotalMajor != '' && this.state.Initial.MajorClose != '') {
            this.state.Initial.MajorOpen = this.state.Initial.TotalMajor - this.state.Initial.MajorClose
            this.setState({})
        }
        else if (this.state.Initial.TotalMajor != '') {
            this.state.Initial.MajorOpen = this.state.Initial.TotalMajor
            this.setState({})
        }
        else {
            this.state.Initial.MajorOpen = this.state.Initial.MajorClose
            this.setState({})
        }
        if (this.state.Initial.TotalMinor != '' && this.state.Initial.MinorClose != '') {
            this.state.Initial.MinorOpen = this.state.Initial.TotalMinor - this.state.Initial.MinorClose
            this.setState({})
        }
        else if (this.state.Initial.TotalMinor != '') {
            this.state.Initial.MinorOpen = this.state.Initial.TotalMinor
            this.setState({})
        }
        else {
            this.state.Initial.MinorOpen = this.state.Initial.MinorClose
            this.setState({})
        }
        if (this.state.Initial.MajorOpen != '' && this.state.Initial.MinorOpen != '') {
            this.state.Initial.NoofFindingsOpen = this.state.Initial.MajorOpen + this.state.Initial.MinorOpen;
            this.setState({})
        }
        else if (this.state.Initial.MajorOpen != '') {
            this.state.Initial.NoofFindingsOpen = this.state.Initial.MajorOpen
            this.setState({})
        }
        else {
            this.state.Initial.NoofFindingsOpen = this.state.Initial.MinorOpen
            this.setState({})
        }

    }
    handleRadio = (event) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.radio = event.target.value
        this.setState({})
    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSelectChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Location = e;
        this.setState({});
    };
    handleProjectNameSearchChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Location = e.target.value;
        this.setState({});
    };
    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                fdata: a,
                FileUrl: await this.toBase64(a),
            }
            this.state.Photos = upload
            this.setState({});
        })
    };
    UploadFile1 = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                fdata: a,
                FileUrl: await this.toBase64(a)
            }
            this.state.CPhotos.push(upload)
            this.setState({})
        })

    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    setCheckbox = (str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.Photos.check = !this.state.Photos.check;
    };
    setCheckbox1 = (str) => {
        this.state.CPhotos.map((i) => {
            if (str == i.FileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };
    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    OpenPopup1 = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }
    DeleteItemCPhoto = () => {
        let tempData = [];
        this.state.CPhotos.map((i) => {
            if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(cfiledeleteiados(this.state.addData.Id, this.state.awsname))
            }
            if (i.FileName != this.state.filename) {
                tempData.push(i)
            }
        })
        { }
        this.state.CPhotos = tempData;
        this.setState({})
        window.$("#deletepopup1").modal("hide");

    }
    DeleteItemPhoto = () => {
        if (this.state.DelIndex == 0) {
            if (this.state.Photos.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeleteiados(this.state.addData.Id, this.state.awsname))
            }
        }
        this.state.Photos = {};
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    DeleteItem = () => {
        if (this.state.value1 == 0) {
            this.state.addData.Id = parseInt(localStorage.getItem("IADOSEditId"))
            this.props.dispatch(deleteIADOS(this.state.addData.Id, this.state.UserRole))
            this.props.navigate("/initialauditdailyobservationstatus")
        }
        else {
            this.deleteInitial(this.state.Initial.Id, this.state.UserRole)
            this.props.navigate("/initialauditdailyobservationstatus")
        }

    }
    deleteInitial = (id, modify) => {
        let apiUrl = API.INITIAL_AUDIT + '/' + id + '?modify=' + modify
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });

    };
    EditCancel = () => {
        window.$("#cancelpopup").modal("hide");
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/initialauditdailyobservationstatus")
    };
    EditCancel1 = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            if (this.state.value === 1) {
                this.setState({
                    value: 0
                })
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate(`/initialauditdailyobservationstatus`)
            }
        }

    };
    ViewCancel = () => {
        this.props.navigate("/initialauditdailyobservationstatus")

    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    openView = (url, name, ind) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.state.index = ind;
        this.setState({})
        window.$('#viewscreen').modal('show')
    }
    openView0 = (url, name) => {
        this.state.fileUrl = url;
        this.state.fileName = name;

        this.setState({})
        window.$('#viewscreen0').modal('show')
    }
    openView1 = (url, name, ind) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.state.index = ind;
        this.setState({})
        window.$('#viewscreen1').modal('show')
    }
    nextView = (ind) => {
        if (this.state.isView ? this.state.ViewData.CompletionPhotos.length === ind : this.state.CPhotos.length === ind) {
            this.setState({
                index: 0
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    preView = (ind) => {
        if (ind === -1) {
            this.setState({
                index: this.state.isView ? this.state.ViewData.CompletionPhotos.length - 1 : this.state.CPhotos.length - 1
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    setIndex = (ind) => {
        this.setState({
            index: ind
        })
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        // $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        // $("#Initial1 .MuiListItemText-primary").addClass("fw-bolder");
        // $("#Initial").removeClass("d-none");
        // $("#Initial").addClass("d-block");
        // $("#IADOSL").addClass("active-color");
        // $("#IADOST").addClass("fw-bolder");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.setState({})
    };
    resize1 = () => {
        $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Initial1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Initial").removeClass("d-none");
        $("#Initial").addClass("d-block");
        $("#IADOSL").addClass("active-color");
        $("#IADOST").addClass("fw-bolder");
    };
    EditSave = () => {
        this.state.cancel = false;
        if (this.state.value1 == 1) {
            if (this.state.Initial.TotalFindings === '') {
                this.state.Error.TotalFindingsError = true;
                this.setState({})
            }
            else {
                this.state.Error.TotalFindingsError = false;
                this.setState({})
            }
            if (this.state.Initial.MajorClose == '') {
                this.state.Error.MajorCloseError = true;
                this.setState({})
            }
            else {
                this.state.Error.MajorCloseError = false;
                this.setState({})
            }
            if (this.state.Initial.MinorClose == '') {
                this.state.Error.MinorCloseError = true;
                this.setState({})
            }
            else {
                this.state.Error.MinorCloseError = false;
                this.setState({})
            }
            if (this.state.Initial.TotalMajor === '') {
                this.state.Error.TotalMajorError = true;
                this.setState({})
            }
            else {
                this.state.Error.TotalMajorError = false;
                this.setState({})
            }
            if (this.state.Initial.TotalMinor === '') {
                this.state.Error.TotalMinorError = true;
                this.setState({})
            }
            else {
                this.state.Error.TotalMinorError = false;
                this.setState({})
            }
            if (this.state.Initial.TotalFindings != '' && this.state.Initial.MajorClose != '' && this.state.Initial.MinorClose != '' && this.state.Initial.TotalMajor != '' && this.state.Initial.TotalMinor != '') {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.putAudit(this.state.Initial.Id, this.state.Initial)
            }
        }
        else {

            if (this.state.addData.Date == "") {
                this.state.Error.DateError = true;
                this.setState({})
            }
            else {
                this.state.Error.DateError = false;
                this.setState({})
            }
            if (this.state.addData.Location.trim() == '') {
                this.state.Error.LocationError = true;
                this.state.addData.Location = this.state.addData.Location.trim();

                this.setState({})

            }
            else {
                this.state.Error.LocationError = false;
                this.state.addData.Location = this.state.addData.Location.trim();

                this.setState({})
            }
            if (this.state.addData.Status == "") {
                this.state.Error.StatusError = true;
                this.setState({})
            }
            else {
                this.state.Error.StatusError = false;
                this.setState({})
            }
            if (this.state.addData.Observation.trim() == "") {
                this.state.Error.ObservationError = true;
                this.state.addData.Observation = this.state.addData.Observation.trim();

                this.setState({})
            }
            else {
                this.state.Error.ObservationError = false;
                this.state.addData.Observation = this.state.addData.Observation.trim();

                this.setState({})
            }
            if (this.state.addData.CorrectiveAction.trim() == '') {
                this.state.Error.CorrectiveActionError = true;
                this.state.addData.CorrectiveAction = this.state.addData.CorrectiveAction.trim();

                this.setState({})

            }
            else {
                this.state.Error.CorrectiveActionError = false;
                this.state.addData.CorrectiveAction = this.state.addData.CorrectiveAction.trim();

                this.setState({})
            }
            if (this.state.addData.ResponsibleDepartment.trim() == "") {
                this.state.Error.ResponsibleDepartmentError = true;
                this.state.addData.ResponsibleDepartment = this.state.addData.ResponsibleDepartment.trim();

                this.setState({})
            }
            else {
                this.state.Error.ResponsibleDepartmentError = false;
                this.state.addData.ResponsibleDepartment = this.state.addData.ResponsibleDepartment.trim();
                this.setState({})
            }
            if (this.state.addData.TargetDate == "") {
                this.state.Error.TargetDateError = true;
                this.setState({})
            }
            else {
                this.state.Error.TargetDateError = false;
                this.setState({})
            }

            if (Object.keys(this.state.Photos).length === 0) {
                this.state.Error.PhotoError = true;
                this.setState({})
            }
            else {
                this.state.Error.PhotoError = false;
                this.setState({})
            }

            if (this.state.addData.Date != '' && this.state.addData.Location != '' && this.state.addData.Status != "" && this.state.addData.Observation != "" && this.state.addData.CorrectiveAction != '' && this.state.addData.ResponsibleDepartment != "" && this.state.addData.TargetDate != "" && this.state.Error.PhotoError == false) {
                this.props.dispatch({ type: "CANCEL", data: false });
                let formData = new FormData()
                if (this.state.addData.Comments != null) {
                    this.state.addData.Comments = this.state.addData.Comments.trim();
                    this.setState({})
                }
                if (this.state.Photos.AwsUniqueFileName == undefined) {
                    formData.append("photo", this.state.Photos.fdata)
                }
                Array.from(this.state.CPhotos).forEach(async (a) => {
                    if (a.AwsUniqueFileName == undefined) {
                        formData.append("completionPhoto", a.fdata)
                    }
                })
                this.addiadosdocinfo(this.state.addData, formData, this.state.addData.Id)
            }
        }


    }
    putAudit = (id, data) => {
        let apiUrl = API.INITIAL_AUDIT + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })

        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/initialauditdailyobservationstatus")

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    }
    addiadosdocinfo = (data, formData, id) => {
        let apiUrl = API.IADOS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    //this.props.navigate("/initialauditdailyobservationstatus")
                    this.adduploadiadosdocinfo(formData, this.state.addData.Id)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    adduploadiadosdocinfo = (data, id) => {
        let apiUrl = API.IADOS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/initialauditdailyobservationstatus")
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    };
    render() {
        let { classes, menuToggle, LocationLookUp } = this.props;
        return (

            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"INIT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="INIT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>{this.state.isView ? "Daily Observation Status" : this.state.value1 == 0 ? "Edit Observation Status" : "Edit Initial Audit "} </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {this.state.value == 1 ? <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={() => this.EditCancel1()}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </> : <>
                                    {this.state.isView ? <td className="border-right" width="5%">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.ViewCancel} ></i></td> :
                                        <td className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={() => this.EditCancel1()}></i></td>
                                    }
                                </>
                                }
                                {this.state.value === 1 ? <></> : <>
                                    {this.state.isView ? <></> :
                                        <td className="border-right text-center">
                                            <span className={classes.button} style={{ minWidth: '60px' }} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                        </td>
                                    }
                                    {this.state.isView ?
                                        <td className="border-right " width="90%">
                                            <>
                                            </>
                                        </td> :
                                        <td className="border-right text-center" >
                                            <span className={`${classes.button}`} style={{ minWidth: '70px' }} onClick={this.EditCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                        </td>}
                                    {this.state.isView ? <></> :
                                        <td className=" text-center" >
                                            <span className={`${classes.button}`} style={{ minWidth: '70px' }} data-target="#deletepopup2" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span>
                                        </td>
                                    }
                                </>}
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        {this.state.isView ?
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.ViewCancel}></i>
                                            :
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i>
                                        }
                                    </td>

                                    <td width="95%">
                                        {this.state.value === 1 ? <></> : <>
                                            {this.state.isView ? <></> :
                                                <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>}
                                            {this.state.isView ? <></> :
                                                <button className={`${classes.button} pl-3`} onClick={this.EditCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>}
                                            {this.state.isView ? <></> :
                                                <button className={`${classes.button} pl-3`} data-target="#deletepopup2" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>}
                                        </>} </td>

                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">{this.state.isView ? "Daily Observation Status" : this.state.value1 == 0 ? "Edit Observation Status" : "Edit Initial Audit "}</h6>}

                        <div className="row">
                            <div >
                                {this.state.isView ? <></> : <>
                                    <AppBar position="static" color="inherit" className={classes.root}>
                                        <Tabs
                                            value={this.state.value}
                                            onChange={this.handleChange}
                                            classes={{ indicator: classes.indicator }}
                                        >
                                            <Tab label="Details" className="px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                            <Tab label="History log" className="" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                                </>}
                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? this.state.isView ? "row" : "row px-0 mt-n3" : "row px-1 mt-n3"}>

                                            {this.state.value1 == 0 ? <>

                                                <div className={`row align-items-center mx-0 ${this.state.isMobile ? "" : "  text-row"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Date&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                disabled

                                                                value={moment(this.state.ViewData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                            <label></label>
                                                        </div> :
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            {this.state.Error.DateError ?
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    error
                                                                    value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                                    placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    onChange={(e) => { this.handleDateChange(e, "Date") }}
                                                                    type="date"
                                                                    id="type-date"
                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                    inputProps={{
                                                                        max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                        min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                                      }}
                                                                />
                                                                :
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    type="date"
                                                                    id="type-date"
                                                                    value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                                    placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    onChange={(e) => { this.handleDateChange(e, "Date") }}
                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                    inputProps={{
                                                                        max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                        min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                                      }}
                                                                />
                                                            }
                                                        </div>}
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Location&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                disabled

                                                                value={this.state.ViewData.Location}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />

                                                        </div> :
                                                        <>
                                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                                {this.state.Error.LocationError ?
                                                                    <div className="autocomplete-wrappers">
                                                                        <Autocomplete
                                                                            contentEditable={true}
                                                                            value={this.state.addData.Location}
                                                                            inputProps={{
                                                                                placeholder: "Location",
                                                                            }}
                                                                            items={LocationLookUp ?? []}
                                                                            getItemValue={(item) => item.Name}
                                                                            shouldItemRender={this.renderProjectNames.bind(this)}
                                                                            renderMenu={(item) => (
                                                                                <div className="dropdowns d-block" >{item}</div>
                                                                            )}
                                                                            renderInput={(props) => {
                                                                                return (
                                                                                    <input
                                                                                        className="form-control border-radius"
                                                                                        id="exampleFormControlInput1"
                                                                                        {...props}
                                                                                        style={{ width: '100%', height: 32, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                            renderItem={(item, isHighlighted) => (
                                                                                <div
                                                                                    className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                                        }`}
                                                                                >
                                                                                    {item.Name}
                                                                                </div>
                                                                            )}
                                                                            onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                                            onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                                        />

                                                                    </div> :
                                                                    <div className=" autocomplete-wrappers">
                                                                        <Autocomplete
                                                                            contentEditable={true}
                                                                            value={this.state.addData.Location}
                                                                            inputProps={{
                                                                                placeholder: "Location",
                                                                            }}

                                                                            items={LocationLookUp ?? []}
                                                                            getItemValue={(item) => item.Name}
                                                                            shouldItemRender={this.renderProjectNames.bind(this)}
                                                                            renderMenu={(item) => (
                                                                                <div className="dropdowns d-block" >{item}</div>
                                                                            )}

                                                                            renderInput={(props) => {
                                                                                return (
                                                                                    <input
                                                                                        className="form-control border-radius"
                                                                                        id="exampleFormControlInput1"
                                                                                        {...props}
                                                                                        style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                                                    />
                                                                                );
                                                                            }}
                                                                            renderItem={(item, isHighlighted) => (
                                                                                <div
                                                                                    className={`items 
                         ${isHighlighted ? "selected-items" : ""
                                                                                        }`}
                                                                                >
                                                                                    {item.Name}
                                                                                </div>
                                                                            )}
                                                                            onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                                            onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                                        />

                                                                    </div>

                                                                }

                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>


                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Category&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            <RadioGroup row value={this.state.ViewData.Category} disabled fullWidth>
                                                                <FormControlLabel value="Major" control={<Radio color="default" />} label="Major" size="small" />
                                                                <FormControlLabel value="Minor" control={<Radio color="default" />} label="Minor" size="small" />
                                                            </RadioGroup>
                                                        </div> :
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            {this.state.Error.CategoryError ?
                                                                <>
                                                                    <RadioGroup row value={this.state.addData.Category} onChange={(e) => { this.handleInputChange(e, "Category") }} fullWidth className={classes.error}>
                                                                        <FormControlLabel value="Major" control={<Radio color="default" className={classes.error} />} label="Major" size="small" />
                                                                        <FormControlLabel value="Minor" control={<Radio color="default" className={classes.error} />} label="Minor" size="small" />
                                                                    </RadioGroup>
                                                                </>
                                                                :
                                                                <RadioGroup row value={this.state.addData.Category} onChange={(e) => { this.handleInputChange(e, "Category") }} fullWidth>
                                                                    <FormControlLabel value="Major" control={<Radio color="default" />} label="Major" size="small" />
                                                                    <FormControlLabel value="Minor" control={<Radio color="default" />} label="Minor" size="small" />
                                                                </RadioGroup>
                                                            }
                                                        </div>}
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Status&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            <RadioGroup row value={this.state.ViewData.Status} disabled fullWidth>
                                                                <FormControlLabel value="Open" control={<Radio color="default" />} label="Open" size="small" />
                                                                <FormControlLabel value="Close" control={<Radio color="default" />} label="Close" size="small" />
                                                            </RadioGroup>
                                                        </div> :
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            {this.state.Error.StatusError ?
                                                                <>
                                                                    <RadioGroup row value={this.state.addData.Status} onChange={(e) => { this.handleInputChange(e, "Status") }} fullWidth className={classes.error}>
                                                                        <FormControlLabel value="Open" control={<Radio color="default" className={classes.error} />} label="Open" size="small" />
                                                                        <FormControlLabel value="Close" control={<Radio color="default" className={classes.error} />} label="Close" size="small" />
                                                                    </RadioGroup>
                                                                </>
                                                                :
                                                                <RadioGroup row value={this.state.addData.Status} onChange={(e) => { this.handleInputChange(e, "Status") }} fullWidth>
                                                                    <FormControlLabel value="Open" control={<Radio color="default" />} label="Open" size="small" />
                                                                    <FormControlLabel value="Close" control={<Radio color="default" />} label="Close" size="small" />
                                                                </RadioGroup>}
                                                        </div>}
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>


                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right mt-n3"}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Observation&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                multiline
                                                                rows={4}
                                                                disabled

                                                                value={this.state.ViewData.Observation}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        </div> :
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                            {this.state.Error.ObservationError ?
                                                                <TextField
                                                                    multiline
                                                                    rows={4}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    error
                                                                    value={this.state.addData.Observation}
                                                                    onChange={(e) => { this.handleInputChange(e, "Observation") }}

                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}


                                                                /> : <TextField
                                                                    multiline
                                                                    rows={4}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    value={this.state.addData.Observation}
                                                                    onChange={(e) => { this.handleInputChange(e, "Observation") }}

                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            }
                                                            <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Observation?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Observation?.length}/500 Characters left</label>
                                                        </div>}
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Photo&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right  border-bottom" : "pt-3 col-md-10"}`}>
                                                            <div className="row px-1">
                                                                {this.state.ViewData.Photos == undefined ? <></> :
                                                                    <>
                                                                        <div
                                                                            className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                                                ? ""
                                                                                : "pt-1 col-md-10 "
                                                                                }`}
                                                                        >
                                                                            <div className="row px-1">
                                                                                <div
                                                                                    className={`col-12 col-sm-4 col-lg-6 col-xl-4 col-md-6 align-items-center  px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                        ? "col-12"
                                                                                        : this.state.isMobile
                                                                                            ? "col-md-4 "
                                                                                            : "col-md-4"
                                                                                        }`}
                                                                                >
                                                                                    <div className="row d-flex">
                                                                                        <div
                                                                                            className={`${window.innerWidth < 290
                                                                                                ? ""
                                                                                                : "col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3"
                                                                                                }`}
                                                                                            onClick={() => { this.openView0(this.state.ViewData.Photos.FileUrl, this.state.ViewData.Photos.FileName) }}
                                                                                        >
                                                                                            <img
                                                                                                className="cursorPointer"
                                                                                                width={
                                                                                                    window.innerWidth < 290
                                                                                                        ? "100%"
                                                                                                        : "257px"
                                                                                                }
                                                                                                src={this.state.ViewData.Photos.FileUrl}
                                                                                                onClick={() => { this.openView0(this.state.ViewData.Photos.FileUrl, this.state.ViewData.Photos.FileName) }}
                                                                                                style={{
                                                                                                    height: "201px",
                                                                                                    marginTop: "-9px",
                                                                                                    objectPosition: "50% 50%",
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }

                                                            </div>
                                                        </div>
                                                        :
                                                        <>
                                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                                {this.state.Error.PhotoError ?
                                                                    <>
                                                                        <TextField
                                                                            error
                                                                            variant="outlined"
                                                                            size="small"
                                                                            style={{ borderColor: 'red' }}
                                                                            fullWidth
                                                                            placeholder="Browse File"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment style={{ marginRight: 0 }}>
                                                                                        <IconButton className="rotate p-0" onClick={this.AttachFiles1}>
                                                                                            <AttachFileIcon />
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ),
                                                                                className: `border-radius  ${classes.inputfieldAlign}`
                                                                            }}

                                                                        />
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            accept=".png,.jpg"
                                                                            onChange={(e) => this.UploadFile(e)}
                                                                            ref={this.inputPhoto}
                                                                        />
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <TextField
                                                                            disabled
                                                                            variant="outlined"
                                                                            size="small"
                                                                            fullWidth
                                                                            accept=".png,.jpg"
                                                                            onChange={(e) => this.UploadFile(e)}

                                                                            placeholder="Browse File"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment style={{ marginRight: 0 }}>
                                                                                        <IconButton className="rotate p-0" onClick={this.AttachFiles1}>
                                                                                            <AttachFileIcon />
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ),
                                                                                className: `border-radius  ${classes.inputfieldAlign}`
                                                                            }}
                                                                        />
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            accept=".png,.jpg"
                                                                            onChange={(e) => this.UploadFile(e)}

                                                                            ref={this.inputPhoto}
                                                                        />
                                                                    </>
                                                                }
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                                                            <div className="row mx-0 px-0">
                                                                <div
                                                                    className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                                        ? "border-left border-right border-bottom col-md-12"
                                                                        : "mt-2"
                                                                        }`}
                                                                >
                                                                    <div
                                                                        className={
                                                                            this.state.isMobile
                                                                                ? "row pl-2 pr-3"
                                                                                : "row px-1"
                                                                        }
                                                                    >
                                                                        {this.state.Photos.FileName == undefined ? <></> : <>
                                                                                    <div
                                                                                        className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                            ? "col-12"
                                                                                            : this.state.isMobile
                                                                                                ? "col-md-4 "
                                                                                                : "col-md-6"
                                                                                            }`}
                                                                                    >
                                                                                        <div className="row d-flex">
                                                                                            <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                                                            <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3">
                                                                                                <img
                                                                                                    src={Delete}
                                                                                                    className="cursorPointer"
                                                                                                    onClick={() => { this.OpenPopup(this.state.Photos.FileName, this.state.Photos.AwsUniqueFileName, this.state.Photos.Id) }}
                                                                                                />
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2"
                                                                                                onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }}
                                                                                            >
                                                                                                <img
                                                                                                    src={this.state.Photos.FileUrl} onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }}
                                                                                                    className="cursorPointer"
                                                                                                    width={
                                                                                                        window.innerWidth < 290
                                                                                                            ? "100%"
                                                                                                            : "257px"
                                                                                                    }
                                                                                                    style={{
                                                                                                        height: "201px",
                                                                                                        marginTop: "-9px",
                                                                                                        objectPosition: "50% 50%",
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                            </>
                                                                            }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div className={`col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                                <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                                    {this.state.Photos.FileName == undefined ? <></> : <>
                                                                        <div
                                                                            className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                ? "col-12"
                                                                                : this.state.isMobile
                                                                                    ? "col-md-4 "
                                                                                    : "col-md-6"
                                                                                }`}
                                                                        >
                                                                            <div className="row d-flex">
                                                                                <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                                                <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3">
                                                                                    <img
                                                                                        src={Delete}
                                                                                        className="cursorPointer"
                                                                                        onClick={() => { this.OpenPopup(this.state.Photos.FileName, this.state.Photos.AwsUniqueFileName, this.state.Photos.Id) }}
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2"
                                                                                    onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }}
                                                                                >
                                                                                    <img
                                                                                        src={this.state.Photos.FileUrl} onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }}
                                                                                        className="cursorPointer"
                                                                                        width={
                                                                                            window.innerWidth < 290
                                                                                                ? "100%"
                                                                                                : "257px"
                                                                                        }
                                                                                        style={{
                                                                                            height: "201px",
                                                                                            marginTop: "-9px",
                                                                                            objectPosition: "50% 50%",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/* <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                                            <div className="row d-flex">
                                                                                <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1" onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }}>
                                                                                    <img className="cursorPointer" src={this.state.Photos.FileUrl} onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }} style={{ width: '40px', height: '36px' }} />
                                                                                </div>
                                                                                <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                                                    <div onClick={() => { this.openView0(this.state.Photos.FileUrl, this.state.Photos.FileName) }} className="cursorPointer mt-0 ml-3 overflow">{this.state.Photos.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(this.state.Photos.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                                </div>
                                                                                <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 pt-1">
                                                                                    <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(this.state.Photos.FileName, this.state.Photos.AwsUniqueFileName, this.state.Photos.Id) }} />
                                                                                </div>
                                                                            </div>
                                                                        </div> 
                                                                    </>}
                                                                </div>
                                                            </div> */}
                                                        </>
                                                    }
                                                </div>

                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2  px-0 text-right mt-n3"}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Corrective Action&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>

                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                disabled
                                                                multiline
                                                                rows={4}

                                                                value={this.state.ViewData.CorrectiveAction}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        </div> :
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                            {this.state.Error.CorrectiveActionError ?
                                                                <TextField
                                                                    multiline
                                                                    rows={4}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    error
                                                                    value={this.state.addData.CorrectiveAction}
                                                                    onChange={(e) => { this.handleInputChange(e, "CorrectiveAction") }}

                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                /> : <TextField
                                                                    multiline
                                                                    rows={4}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    value={this.state.addData.CorrectiveAction}
                                                                    onChange={(e) => { this.handleInputChange(e, "CorrectiveAction") }}

                                                                    fullWidth
                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            }
                                                            <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.CorrectiveAction?.length == undefined ? 500 - 0 : 500 - this.state.addData?.CorrectiveAction?.length}/500 Characters left</label>
                                                        </div>}
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>


                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right mt-n3"}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Responsible Department&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                disabled
                                                                multiline
                                                                rows={4}

                                                                value={this.state.ViewData.ResponsibleDepartment}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        </div>
                                                        :
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                            {this.state.Error.ResponsibleDepartmentError ?
                                                                <TextField
                                                                    multiline
                                                                    rows={4}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    error
                                                                    value={this.state.addData.ResponsibleDepartment}
                                                                    onChange={(e) => { this.handleInputChange(e, "ResponsibleDepartment") }}

                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}


                                                                /> : <TextField
                                                                    multiline
                                                                    rows={4}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    value={this.state.addData.ResponsibleDepartment}
                                                                    onChange={(e) => { this.handleInputChange(e, "ResponsibleDepartment") }}

                                                                    fullWidth
                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            }
                                                            <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.ResponsibleDepartment?.length == undefined ? 500 - 0 : 500 - this.state.addData?.ResponsibleDepartment?.length}/500 Characters left</label>
                                                        </div>
                                                    }
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>


                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Target Date&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    {this.state.isView ?
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                disabled

                                                                value={moment(this.state.ViewData.TargetDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        </div> :
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            {this.state.Error.TargetDateError ?
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    error
                                                                    type="date"
                                                                    id="type-date"
                                                                    value={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format("yyyy-MM-DD")}

                                                                    placeholder={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    onChange={(e) => { this.handleDateChange(e, "TargetDate") }}
                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}

                                                                /> : <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    value={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format("yyyy-MM-DD")}

                                                                    placeholder={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                    onChange={(e) => { this.handleDateChange(e, "TargetDate") }}
                                                                    type="date"
                                                                    id="type-date"
                                                                    InputProps={{
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                            }
                                                        </div>}
                                                    {this.state.isView ? this.state.ViewData.CompletionDate === "" || this.state.ViewData.CompletionDate === null ?
                                                        <>
                                                        </>
                                                        :
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                            <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Completion Date&nbsp;:</label>
                                                        </div>
                                                        :
                                                        <>
                                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                                <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Completion Date&nbsp;:</label>
                                                            </div>
                                                        </>
                                                    }
                                                    {this.state.isView ?
                                                        this.state.ViewData.CompletionDate === "" || this.state.ViewData.CompletionDate === null ? <></> :
                                                            <>
                                                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        size="small"
                                                                        fullWidth
                                                                        disabled

                                                                        value={this.state.ViewData.CompletionDate && moment(this.state.ViewData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                        InputProps={{
                                                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                        }}
                                                                    />
                                                                </div>
                                                            </>
                                                        :
                                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                value={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}

                                                                placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                onChange={(e) => { this.handleDateChange(e, "CompletionDate") }}
                                                                type="date"
                                                                id="type-date"
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        </div>}
                                                </div>
                                                {this.state.isView ?
                                                    this.state.ViewData.CompletionPhotos === [] || this.state.ViewData.CompletionPhotos === null ?
                                                        <>
                                                        </>
                                                        :
                                                        <>
                                                            <div className={`${this.state.isMobile ? "row mx-0 " : "row mx-0 border-left border-right border-bottom"}`}>
                                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right "}`}>
                                                                    <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right mt-4 "}>Completion Photos&nbsp;:</label>
                                                                </div>
                                                                <div
                                                            className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                                    ? "border-left border-right border-bottom"
                                                                    : "pt-1 col-md-10 "
                                                                }`}
                                                        >
                                                            <div className="row px-1">
                                                                {this.state.ViewData.CompletionPhotos &&
                                                                    this.state.ViewData.CompletionPhotos.map((i, ind) => (
                                                                        <div
                                                                            className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center  px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                    ? "col-12"
                                                                                    : this.state.isMobile
                                                                                        ? "col-md-4 "
                                                                                        : "col-md-4"
                                                                                }`}
                                                                        >
                                                                            <div className="row d-flex">
                                                                                <div
                                                                                    className={`${window.innerWidth < 290
                                                                                            ? ""
                                                                                            : "col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3"
                                                                                        }`}
                                                                                        onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }}
                                                                                >
                                                                                    <img
                                                                                        className="cursorPointer"
                                                                                        width={
                                                                                            window.innerWidth < 290
                                                                                                ? "100%"
                                                                                                : "257px"
                                                                                        }
                                                                                        src={i.FileUrl} onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }}
                                                                                        style={{
                                                                                            height: "201px",
                                                                                            marginTop: "-9px",
                                                                                            objectPosition: "50% 50%",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                                {/* <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom" : "pt-3 pb-2 col-md-10"}`}>
                                                                    <div className="row px-2">
                                                                        {this.state.ViewData.CompletionPhotos && this.state.ViewData.CompletionPhotos.map((i, ind) => (
                                                                            <div className={`col-6 col-sm-4 col-lg-3 col-xl-2 align-items-center border-right px-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-4"}`}>
                                                                                <div className="row d-flex">
                                                                                    <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }}>
                                                                                        <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                                    </div>
                                                                                    <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                                                        <div className="cursorPointer pt-2 ml-3 overflow" onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }}>{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        </>

                                                    :
                                                    <>
                                                        <div className={`${this.state.isMobile ? "row mx-0 " : "row mx-0 border-left border-right border-bottom"}`}>
                                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right "}`}>
                                                                <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right mt-4 "}>Completion Photos&nbsp;:</label>
                                                            </div>
                                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                                <TextField
                                                                    disabled
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    accept=".png,.jpg"
                                                                    onChange={(e) => this.UploadFile1(e)}

                                                                    placeholder="Browse File"
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment style={{ marginRight: 0 }}>
                                                                                <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                                    <AttachFileIcon />
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ),
                                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                                    }}
                                                                />
                                                                <input
                                                                    type="file"
                                                                    hidden
                                                                    accept=".png,.jpg"
                                                                    onChange={(e) => this.UploadFile1(e)}
                                                                    multiple="multiple"
                                                                    ref={this.inputCPhoto}
                                                                />
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                                                        <div className="row mx-0 px-0">
                                                            <div
                                                                className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                                        ? "border-left border-right border-bottom col-md-12"
                                                                        : "mt-2"
                                                                    }`}
                                                            >
                                                                <div
                                                                    className={
                                                                        this.state.isMobile
                                                                            ? "row pl-2 pr-3"
                                                                            : "row px-1"
                                                                    }
                                                                >
                                                                    {this.state.CPhotos && this.state.CPhotos.map((i, ind) => {
                                                                            return (
                                                                                <div
                                                                                    className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                            ? "col-12"
                                                                                            : this.state.isMobile
                                                                                                ? "col-md-4 "
                                                                                                : "col-md-6"
                                                                                        }`}
                                                                                >
                                                                                    <div className="row d-flex">
                                                                                        <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                                                        <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3">
                                                                                            <img
                                                                                                src={Delete}
                                                                                                className="cursorPointer"
                                                                                                onClick={() => { this.OpenPopup1(i.FileName, i.AwsUniqueFileName, i.Id) }}
                                                                                            />
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2"
                                                                                            onClick={() => {
                                                                                                this.openView(
                                                                                                    i.FileUrl,
                                                                                                    i.FileName,
                                                                                                    ind
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            <img
                                                                                                src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}
                                                                                                className="cursorPointer"
                                                                                                width={
                                                                                                    window.innerWidth < 290
                                                                                                        ? "100%"
                                                                                                        : "257px"
                                                                                                }
                                                                                                style={{
                                                                                                    height: "201px",
                                                                                                    marginTop: "-9px",
                                                                                                    objectPosition: "50% 50%",
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                            {/* <div className={`col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                                <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                                    {this.state.CPhotos && this.state.CPhotos.map((i, ind) => (
                                                                        <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                                            <div className="row d-flex">
                                                                                <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}>
                                                                                    <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                                </div>
                                                                                <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                                                    <div onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} className="cursorPointer pt-2 ml-3 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                                </div>
                                                                                <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 mt-2 pt-2">
                                                                                    <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup1(i.FileName, i.AwsUniqueFileName, i.Id) }} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    </>
                                                }

                                                {this.state.isView ? <></> : <>
                                                    <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right "}`}>
                                                            <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Comments&nbsp;:</label>
                                                        </div>
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                            <TextField
                                                                multiline
                                                                rows={8}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                value={this.state.addData.Comments}
                                                                onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                            <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                                        </div>
                                                    </div>
                                                </>}
                                            </> : <>
                                                <div className={`row  align-items-center ${this.state.isMobile ? "mx-0" : " mx-0 text-row"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex text-right float-end"}>Total Findings&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        {this.state.Error.TotalFindingsError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                type="number"
                                                                value={this.state.Initial.TotalFindings}
                                                                onChange={(e) => { this.handleNumberChange(e, "TotalFindings") }}


                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}

                                                            /> : <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                value={this.state.Initial.TotalFindings}
                                                                onChange={(e) => { this.handleNumberChange(e, "TotalFindings") }}

                                                                type="number"
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex text-right float-end"}>Total Minor&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        {this.state.Error.TotalMinorError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                type="number"
                                                                value={this.state.Initial.TotalMinor}
                                                                onChange={(e) => { this.handleNumberChange(e, "TotalMinor") }}


                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}

                                                            /> : <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                type="number"
                                                                value={this.state.Initial.TotalMinor}
                                                                onChange={(e) => { this.handleNumberChange(e, "TotalMinor") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex text-right float-end"}>Total Major&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        {this.state.Error.TotalMajorError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                type="number"
                                                                value={this.state.Initial.TotalMajor}
                                                                onChange={(e) => { this.handleNumberChange(e, "TotalMajor") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}

                                                            /> : <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                type="number"
                                                                value={this.state.Initial.TotalMajor}
                                                                onChange={(e) => { this.handleNumberChange(e, "TotalMajor") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  text-right "}`}>
                                                        <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>No.Of Findings Closed&nbsp;:</label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            disabled
                                                            type="number"
                                                            value={this.state.Initial.NoofFindingsClose}
                                                            InputProps={{
                                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                                            }}
                                                        />

                                                    </div>


                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Minor&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        {this.state.Error.MinorCloseError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                type="number"
                                                                value={this.state.Initial.MinorClose}
                                                                onChange={(e) => { this.handleNumberChange(e, "MinorClose") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}

                                                            /> :
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                type="number"
                                                                value={this.state.Initial.MinorClose}
                                                                onChange={(e) => { this.handleNumberChange(e, "MinorClose") }}

                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right "}`}>
                                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Major&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        {this.state.Error.MajorCloseError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                type="number"
                                                                value={this.state.Initial.MajorClose}
                                                                onChange={(e) => { this.handleNumberChange(e, "MajorClose") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}

                                                            /> : <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                type="number"
                                                                value={this.state.Initial.MajorClose}
                                                                onChange={(e) => { this.handleNumberChange(e, "MajorClose") }}
                                                                InputProps={{
                                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  text-right "}`}>
                                                        <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>No.Of Findings Open&nbsp;:</label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            disabled
                                                            value={this.state.Initial.NoofFindingsOpen}
                                                            InputProps={{
                                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                    </div>



                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  text-right "}`}>
                                                        <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Minor&nbsp;:</label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            value={this.state.Initial.MinorOpen}
                                                            disabled
                                                            InputProps={{
                                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                                            }}
                                                        />

                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right "}`}>
                                                        <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Major&nbsp;:</label>
                                                    </div>

                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={this.state.Initial.MajorOpen}
                                                            type="number"
                                                            disabled
                                                            InputProps={{
                                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                                            }}
                                                        />

                                                    </div>
                                                </div>
                                                <div className={this.state.isMobile ? "fw-bold mt-2 px-3" : "fw-bold mt-2 px-1"}>
                                                    Note: For more details, kindly refer "Audit & Corrective  Action" report in the Yard documents.
                                                </div>
                                            </>}


                                        </div>
                                    </div>

                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <div className="row">
                                        <div className="mt-n3">
                                            <div className="col-sm-12 col-12 px-0">
                                                <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                                    <table id="dataTable" className="table">
                                                        <thead>
                                                            <tr className="">
                                                                <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                                <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                                <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                                <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                            {this.props.historyLog && this.props.historyLog.map((i) => (
                                                                <tr>
                                                                    <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                                        {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup2" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>   </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button id="closemodal1" type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>   </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItemPhoto}><span className="" >Delete</span></button>
                                    <button id="closemodal" type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>   </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItemCPhoto}><span className="" >Delete</span></button>
                                    <button id="closemodal2" type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal3" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="viewscreen0" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-3 pl-3 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end' id="viewscreen0" onClick={() => {
                                                window.$('#viewscreen0').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>

                                            <InnerImageZoom
                                                moveType="drag"
                                                zoomScale={2}
                                                hideCloseButton={true}
                                                src={this.state.fileUrl}
                                                hasSpacer={true}
                                                afterZoomIn={() => { $('#viewscreen0 > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                afterZoomOut={() => { $('#viewscreen0 > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="viewscreen1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end mr-3' id="viewscreen1" onClick={() => {
                                                window.$('#viewscreen1').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield1`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                <div class="carousel-indicators">

                                                </div>

                                                <div class="carousel-inner" >
                                                    {this.state.ViewData.CompletionPhotos && this.state.ViewData.CompletionPhotos.map((i, ind) => (<>

                                                        <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                            <div>
                                                                <InnerImageZoom
                                                                    moveType="drag"
                                                                    zoomScale={2}
                                                                    hideCloseButton={true}
                                                                    src={i.FileUrl}
                                                                    hasSpacer={true}
                                                                    afterZoomIn={() => { $('#viewscreen1 > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                    afterZoomOut={() => { $('#viewscreen1 > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                />
                                                            </div>
                                                            {this.state.ViewData.CompletionPhotos.length <= 1 ? "" : <>
                                                                <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Previous</span>
                                                                </button>
                                                                <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Next</span>
                                                                </button>
                                                            </>}

                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end mr-3' id="viewscreen" onClick={() => {
                                                window.$('#viewscreen').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                <div class="carousel-indicators">

                                                </div>
                                                <div class="carousel-inner" >
                                                    {this.state.CPhotos && this.state.CPhotos.map((i, ind) => (<>
                                                        <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                            <div>
                                                                <InnerImageZoom
                                                                    moveType="drag"
                                                                    zoomScale={2}
                                                                    hideCloseButton={true}
                                                                    src={i.FileUrl}
                                                                    hasSpacer={true}
                                                                    afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                    afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                />
                                                            </div>
                                                            {this.state.CPhotos.length <= 1 ? "" : <>
                                                                <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Previous</span>
                                                                </button>
                                                                <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Next</span>
                                                                </button>
                                                            </>}
                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        geteditiados: state.IADOSReducer.geteditiados || [],
        LocationLookUp: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],


        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

EditIADOS.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditIADOS))
);

